// extracted by mini-css-extract-plugin
export default {"ca":"index_ca__+li2M"};